import type { Roadnet } from '../types'

export const SPEED_GEARS = [1, 5, 10, 30, 100] as const

// 曲线按仿真时间每 10 秒取一个样点，只展示最近 30 分钟
export const TREND_BUCKET_S = 10
export const TREND_WINDOW_S = 1800

export type TrendSample = { t: number } & Record<string, number>

export type SeriesDef = { key: string; label: string; color: string }

// 系列色均按深色底 #0d192a 通过色板校验（明度带 / 全对 CVD 区分度 / 对比度）
export const AVERAGE_SERIES: SeriesDef[] = [
  { key: 'pickup', label: '平均接驾', color: '#0d9488' },
  { key: 'trip', label: '平均乘车', color: '#d97706' },
]
export const COUNT_SERIES: SeriesDef[] = [
  { key: 'onTrip', label: '载客车辆', color: '#2a78d6' },
  { key: 'idle', label: '空载车辆', color: '#0d9488' },
  { key: 'waiting', label: '等待乘客', color: '#d97706' },
]

// 裁剪出最近 20 分钟的样点
export function sliceWindow(points: TrendSample[]): TrendSample[] {
  if (!points.length) return points
  const cutoff = points[points.length - 1].t - TREND_WINDOW_S
  return points.filter((item) => item.t >= cutoff)
}

// 倍速 <10×：100ms 一帧如实渲染；倍速 ≥10×：500ms 一帧后台多算、只渲染返回帧（抽帧）
export function pollPlan(speed: number): { intervalMs: number; advanceS: number } {
  if (speed >= 10) return { intervalMs: 500, advanceS: speed * 0.5 }
  return { intervalMs: 100, advanceS: speed * 0.1 }
}

export function formatClock(seconds: number): string {
  const total = Math.max(0, Math.floor(seconds))
  const hours = Math.floor(total / 3600).toString().padStart(2, '0')
  const minutes = Math.floor((total % 3600) / 60).toString().padStart(2, '0')
  const rest = (total % 60).toString().padStart(2, '0')
  return `${hours}:${minutes}:${rest}`
}

// OrthographicView(flipY: false) 下按路网范围计算初始视野：target 取中心，zoom 适配约 900px 的视口
export function fitViewState(roadnet: Roadnet): { target: [number, number, number]; zoom: number } {
  if (!roadnet.nodes.length) return { target: [0, 0, 0], zoom: 0 }
  let minX = Infinity
  let minY = Infinity
  let maxX = -Infinity
  let maxY = -Infinity
  for (const node of roadnet.nodes) {
    minX = Math.min(minX, node.x)
    minY = Math.min(minY, node.y)
    maxX = Math.max(maxX, node.x)
    maxY = Math.max(maxY, node.y)
  }
  const range = Math.max(maxX - minX, maxY - minY, 1)
  return {
    target: [(minX + maxX) / 2, (minY + maxY) / 2, 0],
    zoom: -Math.log2(range / 900),
  }
}
